<script>
import wtBox from '../box'
// 组件class前缀
const prefixCls = 'wt-count-down-box'

export default {
  name: 'wt-count-down-box',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    // 倒计时总时间
    count: {
      type: Number,
      default: 60
    },
    // 时间单位
    unit: {
      type: String,
      default: 's'
    },
    // 是否在点击后立即出发倒计时，如果为false，需要在组件外部，调用start方法开始倒数
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 是否启用按钮
      enableBtn: true,
      // 当前剩余时间
      Count: this.count,
      // 定时器
      timer: null,
      // 是否即将开始倒计时
      readyToStart: false
    }
  },
  render (h) {
    if (this.enableBtn) {
      return h(wtBox, {
        class: `wt-count-down-box`,
        nativeOn: {
          click: this._clickHanller
        }
      }, this.$slots.default)
    } else {
      return h(wtBox, {
        class: `wt-count-down-box down disabled`
      }, this.Count + this.unit)
    }
  },
  methods: {
    _clickHanller () {
      if (this.readyToStart) {
        // 这里加这个判断，是为了防止用户在开始倒计时前重复点击
        return
      }
      this.immediate ? this.start() : this.$emit('on-start', this.start)
      this.readyToStart = true
    },
    // 开始倒计时
    start () {
      this.Count = this.count
      this.enableBtn = false
      this.timer = setInterval(_ => {
        this.Count -= 1
        if (this.Count <= 0) {
          this.stop()
          this.enableBtn = true
          this.readyToStart = false
        }
      }, 1000)
    },
    // 暂停倒计时
    stop () {
      this.timer && clearInterval(this.timer)
    },
    // 重置
    reset () {
      this.timer && clearInterval(this.timer)
      this.Count = this.count
      this.enableBtn = true
      this.readyToStart = false
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-count-down-box {
  min-width: 7.4em;
  min-height: 2em;
  padding:0 1em;
  border: 1px solid currentColor;
  //border-radius: 2rem;
  color: currentColor;
  &.disabled {
    color: #999 !important;
    border-color: #ccc;
    background-color:#eee!important;
  }
}
</style>
